module.exports = __webpack_public_path__ + "static/media/CMagazine_PPpress_small.fcdca2ca.jpg";